import { connect } from 'react-redux';
import { withBiEvent } from 'shared/bi/send-bi-event';
import autobind from 'core-decorators/lib/autobind';

import { notForPreview } from 'widget/utils/not-for-preview';

import { playVideo } from 'widget/redux/client/actions/change-playback-status';
import { selectVideo } from 'widget/redux/client/actions/select-video';

import {
  openFullScreenOverlay,
  openFullScreenPurchaseOverlay,
  openFullScreenMemberOnlyOverlay,
  openFullScreenSubscribeOverlay,
} from 'shared/utils/open-overlay';


@connect(null, {
  playVideo,
  selectVideo,
})
export default class InFrameActionCallbacks extends React.Component {

  static propTypes = {
    children: React.PropTypes.element.isRequired,
    selectVideo: React.PropTypes.func.isRequired,
    playVideo: React.PropTypes.func.isRequired,
    onBeforeClick: React.PropTypes.func,
    onBeforePlayRequested: React.PropTypes.func,
    channelId: React.PropTypes.string,
    videoId: React.PropTypes.string,
    videoSource: React.PropTypes.string,
  };

  @autobind
  selectVideo() {
    const { selectVideo, videoId } = this.props;
    selectVideo(videoId);
  }

  @autobind
  @withBiEvent('widget.vid.clicked', function () {
    const { channelId, videoId, videoSource } = this.props;

    return {
      channelID: channelId,
      videoID: videoId,
      videoType: videoSource,
    };
  })
  playVideo() {
    const { playVideo, videoId } = this.props;
    playVideo(videoId);
  }

  @autobind
  @notForPreview
  showVideoAtOverlay() {
    const { channelId, videoId } = this.props;
    openFullScreenOverlay(`#/channel/${channelId}/video/${videoId}`);
  }

  @autobind
  @notForPreview
  showVideoMemberOnlyInfo() {
    const { channelId, videoId } = this.props;
    openFullScreenMemberOnlyOverlay(channelId, videoId);
  }

  @autobind
  @notForPreview
  showVideoPurchaseInfo() {
    const { channelId, videoId } = this.props;
    openFullScreenPurchaseOverlay(channelId, videoId);
  }

  @autobind
  @notForPreview
  showChannelSubscriptionInfoAtOverlay() {
    openFullScreenSubscribeOverlay(this.props.channelId);
  }

  @autobind
  handleSelectVideo() {
    this.props.onBeforeClick();
    this.selectVideo();
  }

  @autobind
  handlePlayVideo() {
    this.props.onBeforePlayRequested();
    this.playVideo();
  }

  render() {
    return React.cloneElement(this.props.children, {
      onClick: this.handleSelectVideo,
      onPlayRequest: this.handlePlayVideo,
      onPlayMemberOnlyRequest: this.showVideoMemberOnlyInfo,
      onPlayWithoutPreviewRequest: this.showVideoAtOverlay,
      onPurchaseRequest: this.showVideoPurchaseInfo,
      onSubscriptionRequest: this.showChannelSubscriptionInfoAtOverlay,
    });
  }
}




// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/actions/overlay-action-callbacks/in-frame.js